<p-table [value]="[
{ name: 'Зарегистрировано онлайн', value: data.onlineRegistered },
{ name: 'Зарегистрировано оффлайн', value: data.offlineRegistered },
{
  name: 'Зарегистрировано всего',
  value: data.registered,
  bold: true,
  class: 'bg-blue-50'
},
{ name: 'Посетило онлайн', value: data.visitedOnline },
{ name: 'Посетило оффлайн', value: data.visitedOffline },
{
  name: 'Посетило всего',
  value: data.visited,
  bold: true,
  class: 'bg-blue-100'
},
{
  name: 'Оплаченных',
  value: data.paid,
  bold: true,
  class: 'bg-green-50'
}
]" [rowHover]="true" [responsive]="true">
<ng-template pTemplate="caption">
Сводка
</ng-template>
<ng-template pTemplate="header">
  <tr>
    <th style="padding: 0.5rem 1rem">Категория</th>
    <th class="text-center" style="padding: 0.5rem 1rem">Значение</th>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-row>
  <tr [ngClass]="row.class">
    <td [ngClass]="{ 'font-bold': row.bold }" style="padding: 0.5rem 1rem">
      {{ row.name }}
    </td>
    <td class="text-center" [ngClass]="{ 'font-bold': row.bold }" style="padding: 0.5rem 1rem">
      {{ row.value }}
    </td>
  </tr>
</ng-template>
</p-table>
